import React, { useEffect } from "react";
import { Col, Container, Row, FormGroup} from "react-bootstrap";
import { Input, Form, Checkbox, Select} from 'antd';
import { AuthHeader, ImageElement } from "../../components";
import { Link } from "react-router-dom";

function Signup() {
    useEffect(() => {
        let navbar = document.querySelector(".header");
        let navbarHeight = navbar?.clientHeight;
        let authPage = document.querySelector(".authPage_inner");
        if(authPage){
        authPage.style.minHeight = `${window.innerHeight - navbarHeight}px`;
        }
    });
    return (
        <>
            <AuthHeader/>
            <main className="authPage">
                <div className="authPage_inner d-flex flex-column justify-content-center align-items-center">
                    <Container>
                        <Row className="g-0 align-items-center">
                            <Col xxl="6" lg="5" className="d-none d-lg-block">
                                <div className="authPage_left">
                                    <ImageElement source="auth-img.png" className="img-fluid"/>
                                </div>
                            </Col>
                            <Col xxl="6" lg="7">
                                <div className="authPage_right signPd w-100 ms-auto">
                                    <div className="authPage_top w-100 mx-auto authPage_top-authBook">
                                        <h1 className="authPage_top_title mb-0 text-center">Book Online</h1>
                                        <div className="authPage_top_sign">
                                            <Form>    
                                                <Row>   
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label w-100">First Name</label>
                                                            <Input size="large" placeholder="Enter First Name" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label w-100">Last Name</label>
                                                            <Input size="large" placeholder="Enter Last Name" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label w-100">Email ID</label>
                                                            <Input type="email" size="large" placeholder="Enter Email" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group form-group-number">
                                                            <label className="ant-label w-100">Mobile Number</label>
                                                            <div className="position-relative">
                                                                <Input size="large" value="1234567890" placeholder="Number" />
                                                                <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                                                    {/* <ImageElement source="indian-flag.svg" className="me-2" /> */}
                                                                    <Select size="large" className="w-100" placeholder="+91"
                                                                        options={[
                                                                            {
                                                                                value: 'India',
                                                                                label: '+91',
                                                                            }
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </FormGroup>
                                                        {/* <FormGroup className="form-group form-group-number auth">  
                                                            <label className="ant-label w-100">Mobile Number</label>     
                                                            <div className="position-relative">                                            
                                                                <Input size="large" placeholder="" />
                                                                <div className="form-cstm position-absolute top-0 ">
                                                                    <Select size="large" className="w-100" placeholder="+1"
                                                                        options={[
                                                                            {
                                                                                value: 'India',
                                                                                label: '+91',
                                                                            },
                                                                            {
                                                                                value: 'India',
                                                                                label: '+1',
                                                                            }
                                                                        ]}
                                                                    />
                                                            </div> 
                                                        </div>
                                                        </FormGroup> */}
                                                    </Col>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label w-100">Password</label> 
                                                            <Input.Password size="large" placeholder="Password" iconRender={visible => (visible ? <div><em className="gg-eye-on"/></div> : <div><em className="gg-eye-off"/></div>)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group mb-0">
                                                            <label className="ant-label w-100">Confirm Password</label> 
                                                            <Input.Password size="large" placeholder="Confirm Password" iconRender={visible => (visible ? <div><em className="gg-eye-on"/></div> : <div><em className="gg-eye-off"/></div>)}/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>   
                                                <div className="text-center authPage_top_terms">
                                                    <Checkbox>I agree with </Checkbox><Link to="/terms-conditions" className="forgotxt mb-0">Terms & Conditions</Link>
                                                </div>
                                                <Link to='/dashboard'  size="lg" className="w-100 btn btn-primary btn-lg" type="submit">Book Online</Link>
                                                {/* <Button variant="primary" size="lg" className="w-100" type="submit">Sign Up</Button> */}
                                                <div className="text-center authPage_top_txt mb-0">
                                                    Already have an account ? <Link  to="/login" className="forgotxt font-md mb-0">Login</Link>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>
        </>
    );
  }
  
  export default Signup;